// ลบ emoji ออกจากข้อความที่ระบบสร้างเอง (ข้อความระบบในห้องแชท/แจ้งเตือน) — รวมของเก่าที่เคยบันทึกไว้
// ใน Firestore พร้อม emoji ตอนแสดงผล (ไม่แตะข้อความที่ผู้ใช้พิมพ์เอง)
const EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{2604}\u{2607}-\u{26FF}\u{2705}\u{270A}-\u{270D}\u{2728}\u{274C}\u{274E}\u{2753}-\u{2757}\u{2B50}\u{2B06}\u{2B07}\u{23E9}-\u{23FA}\u{231A}\u{231B}\u{21A9}\u{21AA}\u{2194}\u{2139}\u{FE0F}\u{200D}]/gu;

export function stripEmoji(text) {
  if (typeof text !== "string") return text;
  return text.replace(EMOJI_RE, "").replace(/[ \t]{2,}/g, " ").replace(/^\s+/, "");
}
